module.exports = "/assets/data/76f5bbdcf8004ad2b698049bb1de074b-LE8.data.json";